

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.5qx0LwGf.js","_app/immutable/chunks/disclose-version.BrU4QSF1.js","_app/immutable/chunks/runtime.B_Tq2JvT.js","_app/immutable/chunks/legacy.CBDsMKFl.js","_app/immutable/chunks/slot.BwfeXIX-.js","_app/immutable/chunks/lifecycle.DvZSA9rW.js","_app/immutable/chunks/entry.CdY5ug-x.js","_app/immutable/chunks/index-client.Dxzap11L.js","_app/immutable/chunks/index.Cfv-du2c.js"];
export const stylesheets = [];
export const fonts = [];
